module.exports = __webpack_public_path__ + "media/images/music-council-605eb8641d03cdfe3839e4ced1e17587.png";